import { List } from 'immutable';
import React from 'react';
import { Fun, IOWidget, mk_widget, nothing } from 'widgets-for-react';
import { video } from '../../video';
import { Breadcrumb } from '../../wordpress/types_and_parser/extra_types.mod';
import { ExtraImages } from '../utils/extra_images.mod';
import { Author } from './page_header.mod';

export type PageFooterProps<extra_images> =
  | { kind: 'empty' }
  | NewsPageFooterProps<extra_images>  

type NewsPageFooterProps<extra_images> = {
  kind: 'news',
  author: Author
}

export const pageFooter: Fun<List<Breadcrumb>, IOWidget<PageFooterProps<ExtraImages>, never>> = breadcrumbs => props =>
  props.kind == 'news'
    ? newsFooter(breadcrumbs)(props)
    : nothing()

export const newsFooter: Fun<List<Breadcrumb>, IOWidget<NewsPageFooterProps<ExtraImages>, never>> = breadcrumbs => props => mk_widget({
  run: () => (
    <footer className="author block block--small">
      <div className="author__visual">
        <img 
          className="author__image"
          src={props.author.image_src} 
          alt={props.author.image_alt}
        />
      </div>
      <div className="author__text">
        <span className="author__title title--m">{props.author.name}</span>
        <span className="author__subtitle title--xs">{props.author.job}</span>
      </div>
    </footer>
  )
})
